var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50008 1.41663C4.583 1.41663 1.41675 4.58288 1.41675 8.49996C1.41675 12.417 4.583 15.5833 8.50008 15.5833C12.4172 15.5833 15.5834 12.417 15.5834 8.49996C15.5834 4.58288 12.4172 1.41663 8.50008 1.41663ZM11.5459 11.5458C11.2697 11.822 10.8234 11.822 10.5472 11.5458L8.50008 9.49871L6.453 11.5458C6.17675 11.822 5.7305 11.822 5.45425 11.5458C5.178 11.2695 5.178 10.8233 5.45425 10.547L7.50133 8.49996L5.45425 6.45288C5.178 6.17663 5.178 5.73038 5.45425 5.45413C5.7305 5.17788 6.17675 5.17788 6.453 5.45413L8.50008 7.50121L10.5472 5.45413C10.8234 5.17788 11.2697 5.17788 11.5459 5.45413C11.8222 5.73038 11.8222 6.17663 11.5459 6.45288L9.49883 8.49996L11.5459 10.547C11.8151 10.8162 11.8151 11.2695 11.5459 11.5458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.759d4516e91d97821c42ce72abe619c5.svg";
export { ForwardRef as ReactComponent };